// import axios from 'axios';
// import tokenService from './token.service';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; 
import { toast } from 'sonner';
import tokenService from './token.service';
import history from './history';
import { baseURL } from './baseURL.service';

const coreClient = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

coreClient.interceptors.request.use((config) => {
    const token = tokenService.getLocalAccessToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});



coreClient.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
            const newAccessToken = await tokenService.refreshToken();
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
            return coreClient(originalRequest);
        } catch (refreshError) {
            tokenService.removeUser();
            return Promise.reject(refreshError);
        }
    }

    return Promise.reject(error);
});

export default coreClient;
